import { makeStyles, createStyles, Theme } from '@material-ui/core';

import { PaginationAlignment, PaginationPosition } from '.';

interface StyleProps {
  alignment?: PaginationAlignment;
  position?: PaginationPosition;
}

export const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    container: {
      display: 'flex',
      alignItems: 'center',
      width: '100%',
      marginTop: ({ position }: StyleProps) =>
        position === 'top' || position === 'both' ? theme.spacing(3) : 0,
      marginBottom: ({ position }: StyleProps) =>
        position === 'top' || position === 'both' ? theme.spacing(3) : 0,
      justifyContent: ({ alignment }: StyleProps) => {
        switch (alignment) {
          case 'left':
            return 'flex-start';
          case 'center':
            return 'center';
          case 'right':
            return 'flex-end';
          default:
            return 'flex-end';
        }
      },
    },
    dataLabel: {
      fontSize: theme.typography.pxToRem(14),
      color: theme.palette.text.secondary,
      fontWeight: 'bold',

      '& + p': {
        marginRight: theme.spacing(2),
      },
    },
    secondDataLabel: {
      marginRight: '0 !important',
    },
    skeleton: {
      transform: 'none',
      marginRight: theme.spacing(2),
    },
  }),
);
